import React from 'react';
import { ScorecardPizzaTracker } from '../../../components/scorecardPizzaTracker/ScorecardPizzaTracker';
import { PayPeriodParticipantLandingPage } from '../payPeriodParticipantLandingPage/PayPeriodParticipantLandingPage';

export interface ApprovalLandingPageProps {
    inputMonth: number;
    inputYear: number;
    scorecardVersionID: number | string;
    scorecardName?: string;
}

export const ApprovalLandingPage = ({
    inputMonth,
    inputYear,
    scorecardVersionID,
    scorecardName,
}: ApprovalLandingPageProps) => {
    return (
        <div style={{ borderRadius: '1rem', padding: '0.5rem 1rem' }}>

            <div style={{ width: '100%' }}>
                <ScorecardPizzaTracker
                    inputYear={inputYear}
                    inputMonth={inputMonth}
                    inputScorecardVersion={
                        typeof scorecardVersionID === 'string' ? Number(scorecardVersionID) : scorecardVersionID
                    }
                    fromCompensation={false}
                />
            </div>

            <hr style={{ borderTop: '1px solid #e5e7eb', margin: '0.75rem 0' }} />

            <div style={{ width: '100%' }}>
                <PayPeriodParticipantLandingPage
                    inputMonth={inputMonth}
                    inputYear={inputYear}
                    scorecardVersionID={scorecardVersionID}
                    scorecardName={scorecardName}
                />
            </div>

        </div>
    );
};
